import axios from './axios-instance';

import Auth from '@aws-amplify/auth';

/**
 * `post` is a thin wrapper around `axios.post`. Using axios directly is
 * recommended.
 *
 * @deprecated
 * @param  {String} uri     The uri to request
 * @param  {Object} headers An object containing headers
 * @param  {Object} headers An object containing the body
 * @param  {Boolean} fullResponse
 * @return {Promise}	    A Promise
 */
export default async function post(
	uri,
	body = {},
	_headers = {},
	fullResponse = false
) {
	const skipLogin =
		typeof localStorage !== 'undefined' &&
		JSON.parse(localStorage.getItem('skipLogin'));
	let accessToken = '';
	let session = '';
	if (!skipLogin) {
		try {
			session = await Auth.currentSession();
		} catch (err) {
			console.log(err);
		}
		if (session.idToken) {
			accessToken = session.idToken.jwtToken;
		}
	} else {
		accessToken = localStorage.getItem('accessToken');
	}
	const authorization = accessToken
		? { Authorization: `Bearer ${accessToken}` }
		: {};
	const headers = Object.assign({}, _headers, authorization);
	return axios
		.post(uri, body, {
			headers,
		})
		.then((response) => (fullResponse ? response : response.data))
		.catch((err) => {
			return Promise.reject(err);
		});
}
